/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Button } from 'reactstrap';
import { radiusEndpointBase } from '../../../constants/Endpoint';
import { useContext } from 'react';
import { LoginContext } from '../../../Context';

const TwitterLoginButton = (props) => {
  const loginContext = useContext(LoginContext);
  const authenticationUrl = loginContext.config?.dashboardDomain ? `https://${loginContext.config?.dashboardDomain}:8080/twitter/guest/authenticate` : `${radiusEndpointBase}twitter/guest/authenticate`;
 
   const getURLWithQueryParams = (base, params) => {
     const query = Object
       .entries(params)
       .filter(([, value]) => value != null )
       .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
       .join('&')
       
     return `${base}?${query}`
   }

  const handleOnClick = () => {
    const currentUrl = window.location.href;
    const lastSlashIndex = currentUrl.lastIndexOf("/");
    const urlStrippedRoute = currentUrl.substring(0, lastSlashIndex);
    const urlVerifyRoute = urlStrippedRoute + "/verify";

    // Send the initial request to start the workflow
    // cloud should respond with an html page containing router info after user signs in
    const twitterUrl = getURLWithQueryParams(authenticationUrl, {
      redirect_url: urlVerifyRoute
    });

    const url = new URL(twitterUrl, window.location.href);

    // navigate to url
    window.location.href = url.toString();
  }
  
  return <Button {...props} onClick={handleOnClick} />;
};

export default TwitterLoginButton;
